import { registerAction } from '../../Action'

const TOGGLE_MOMENT_SELECT = 'TOGGLE_MOMENT_SELECT'

const reducer = (state = {}, action) => {
  let moment = action.payload

  if (state.selectedMoment && state.selectedMoment.id === action.payload.id) {
    moment = null
  }

  return {
    ...state,
    selectedMoment: moment,
  }
}

const toggleMomentSelect = registerAction(TOGGLE_MOMENT_SELECT, { reducer })

export default toggleMomentSelect
